export interface IManagementList {
  companyUsers: IManagement[];
}

export interface IManagementCreate {
  name: string;
  email: string;
  isSuperUser: boolean;
}

export interface IManagement {
  _id: string;
  name: string;
  email: string;
  isSuperUser: boolean;
}

export const ManagementDefaultValues: IManagementCreate = {
  name: '',
  email: '',
  isSuperUser: false,
};

